import { injectStyle } from '../shared/utils';

export const installC360Fonts = () => {
  const fonts = ['Inter:400,500,600,700,800,900'];
  const _fonts = encodeURIComponent(fonts.join('|'));
  injectStyle(`https://fonts.googleapis.com/css?family=${_fonts}&display=swap`);
};
